import { NavLink } from 'react-router-dom';
import TextWinds from './TextWinds';

interface NavCardProps {
  to: string;
  /** 카드 상단 이미지. 없으면 텍스트만 표시 */
  imageSrc?: string;
  /** 첫째 줄. 두 줄 모두 같은 스타일이라 의미 위계 없이 위치로 구분 */
  topText?: string;
  /** 둘째 줄 */
  bottomText?: string;
  /** 새 탭으로 열기 (외부 링크용) */
  blank?: boolean;
}

/** 데이터 로딩 중 NavCard 자리 표시 (이미지 + 1줄 텍스트 기준) */
export const NavCardSkeleton = () => (
  <div className="box-border w-full animate-pulse rounded border-2 bg-white px-6 py-3 shadow-md shadow-blue-gray-500/10">
    <div className="mx-auto aspect-square w-full max-w-[100px] rounded bg-gray2" />
    <div className="mx-auto mt-2 h-5 w-1/2 rounded bg-gray2 lg:h-7" />
  </div>
);

/** 그리드 셀용 링크 카드. 이미지 + 2줄 텍스트 (코스 찾기 / 커뮤니티 찾기 / 내 학습 공용) */
export const NavCard = ({
  to,
  imageSrc,
  topText,
  bottomText,
  blank,
}: NavCardProps) => (
  <NavLink
    to={to}
    target={blank ? '_blank' : undefined}
    rel={blank ? 'noopener noreferrer' : undefined}
    className="box-border block w-full rounded border-2 bg-white px-6 py-3 text-center shadow-md shadow-blue-gray-500/10 transition-all hover:shadow-lg hover:shadow-blue-gray-500/20 active:opacity-[0.85]"
  >
    {/* 장식 이미지 - 바로 아래 텍스트가 같은 내용이므로 alt 비움 */}
    {imageSrc && (
      <img className="mx-auto w-full max-w-[100px]" src={imageSrc} alt="" />
    )}

    {topText && (
      <TextWinds
        type="button"
        color="purple5"
        className="block text-sm lg:text-lg"
      >
        {topText}
      </TextWinds>
    )}

    {bottomText && (
      <TextWinds
        type="button"
        color="purple5"
        className="block text-sm lg:text-lg"
      >
        {bottomText}
      </TextWinds>
    )}
  </NavLink>
);
